import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import {
  deleteCabVendor,
  fetchCabVendors,
  refreshCabVendorList,
  // listCabVendors,
} from "src/store/reducers/cabVendors";
// import MainPagetitle from "../../../jsx/layouts/MainPagetitle";
import ConfirmationModal from "src/layouts/modals/ConfirmationModal";
import { toast } from "react-toastify";
import CabVendorFormCanvas from "./CabVendorFormCanvas";
import { FormikAPIErrorHandler } from "src/utils/errorUtil";
import BottomPagination from "src/jsx/customComponents/pagination/BottomPagination";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Button } from "react-bootstrap";
import CustomInputWithLabel from "src/layouts/form/CustomInputWithLabel";

const ListCabVendors = () => {
  const dispatch = useAppDispatch();
  const cabVendorList = useAppSelector((state) => state.cabVendors.data);
  const cabVendorListStatus = useAppSelector(
    (state) => state.cabVendors.status
  );
  const [editId, setEditId] = useState("");
  const [deleteCabVendorId, setDeleteCabVendorId] = useState<string>();
  // const [checkedList, setCheckedList] = useState<number[]>([]);
  const [page, setPage] = useState(1);
  // const sort = 5;

  const [pending, setPending] = useState(false);
  const keywordRef = useRef("");

  const {
    handleChange,
    values,
    handleSubmit,
    // resetForm,
    // setFieldValue,
    // touched,
    // errors,
  } = useFormik({
    initialValues: {
      keyword: "",
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      keyword: Yup.string(),
    }),
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: (values) => {
      setPending(true);
      keywordRef.current = values.keyword;
      setPage(1);
      dispatch(fetchCabVendors({ page: 1, keyword: values.keyword }));
      setPending(false);
    },
  });

  const retry = useCallback(() => {
    dispatch(fetchCabVendors({ page, keyword: keywordRef.current }));
  }, [dispatch, page]);

  const cancelDelete = () => {
    setDeleteCabVendorId(undefined);
  };

  const confirmDelete = useCallback(async () => {
    if (deleteCabVendorId) {
      try {
        const data = await dispatch(
          deleteCabVendor(deleteCabVendorId)
        ).unwrap();
        toast.success("Cab Vendor is deleted successfully");
        setDeleteCabVendorId(undefined);
        setPage(1);
        retry();
      } catch (e: any) {
        FormikAPIErrorHandler(e.message, undefined, toast.error);
      }
    }
  }, [deleteCabVendorId, dispatch, retry]);

  useEffect(() => {
    if (cabVendorListStatus === "idle") {
      retry();
    }
  }, [cabVendorListStatus, retry]);

  useEffect(() => {
    return () => {
      dispatch(refreshCabVendorList());
    };
  }, [dispatch]);

  const setPageAndFetch = useCallback(
    (newPage: number) => {
      setPage(newPage);
      dispatch(fetchCabVendors({ page: newPage, keyword: keywordRef.current }));
    },
    [dispatch]
  );

  return (
    <>
      {/* <MainPagetitle
        mainTitle="Cab Vendors"
        pageTitle="Cab Vendors"
        parentTitle="Home"
      /> */}
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12 col-xxl-12">
            <div className="card h-auto">
              <form onSubmit={handleSubmit}>
                <div className="row container-fluid">
                  <div className="col-xl-3 mb-3">
                    <CustomInputWithLabel
                      id="keyword"
                      placeholder={"Search"}
                      handleChange={handleChange}
                      value={values.keyword}
                    />
                  </div>
                  <div className="col-xl-2 mb-3">
                    <Button
                      className="form-control"
                      disabled={pending}
                      type="submit"
                    >
                      {pending ? "Loading" : "Submit"}
                    </Button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12 col-xxl-12">
            <div className="card h-auto">
              <div className="card-header">
                <h4 className="heading mb-0">Cab Vendors</h4>
                <Link
                  to={"#"}
                  className="btn btn-primary btn-sm"
                  data-bs-toggle="offcanvas"
                  onClick={() => setEditId("Add")}
                >
                  {/* <i className="fa-solid fa-plus me-2"></i> */}
                  {/* <span className="btn-icon-start text-info">
                    <i className="fa fa-plus color-info"></i>
                  </span> */}
                  + Add Cab Vendor
                  {/* <span className="btn-icon-end">
                    <i className="fa fa-plus"></i>
                  </span> */}
                </Link>
              </div>
              <div className="card-body ">
                {cabVendorListStatus === "success" ? (
                  cabVendorList?.results &&
                  cabVendorList?.results.length > 0 ? (
                    <div className="table-responsive active-projects">
                      {/* <div className="tbl-caption d-flex justify-content-between flex-wrap align-items-center">
                      <h4 className="heading mb-0">CabVendors</h4>
                    </div> */}
                      <div
                        id="projects-tbl_wrapper"
                        className="dataTables_wrapper no-footer"
                      >
                        <table
                          id="projects-tbl"
                          className="table table-hover dataTable no-footer mb-0"
                        >
                          <thead>
                            <tr>
                              <th>Contact Person Name</th>
                              <th>Company Name</th>
                              <th>Contact Number</th>
                              <th>City</th>
                              {/* <th>Created Date</th> */}
                              {/* <th>Status</th> */}
                              {/* <th>Number</th> */}
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {cabVendorList?.results?.map((cabVendor, index) => (
                              <tr key={cabVendor.id}>
                                <td>{cabVendor.contact_person_name}</td>
                                <td>{cabVendor.company_name}</td>
                                <td>{cabVendor.contact_number}</td>
                                <td>{cabVendor.city}</td>
                                {/* 
                                <td>
                                  <span className="tag tag-success">
                                    {UserRole[cabVendor.status]}
                                  </span>
                                </td> */}
                                <td>
                                  <NavLink
                                    className="btn btn-warning shadow btn-xs sharp me-1"
                                    to={`/cab-vendors/view/${cabVendor.id}`}
                                    title="View"
                                  >
                                    <i className={`fas fa-paper-plane`} />
                                    {/* <span>View</span> */}
                                  </NavLink>{" "}
                                  <NavLink
                                    // btn btn-primary shadow btn-xs light me-1
                                    className="btn btn-primary shadow btn-xs sharp me-1"
                                    onClick={() => setEditId(cabVendor.id)}
                                    to={"#"}
                                    title="Edit"
                                  >
                                    <i className={`fas fa-pen`} />
                                    {/* <span>Edit</span> */}
                                  </NavLink>{" "}
                                  <NavLink
                                    className="btn btn-danger shadow btn-xs sharp"
                                    onClick={() => {
                                      setDeleteCabVendorId(cabVendor.id);
                                    }}
                                    to={`#`}
                                    title="Delete"
                                  >
                                    <i className={`fas fa-x`} />
                                  </NavLink>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        <BottomPagination
                          count={cabVendorList?.count}
                          page={page}
                          setPageAndFetch={setPageAndFetch}
                        />
                      </div>
                    </div>
                  ) : (
                    <div className="d-flex align-items-center">
                      <strong>NA</strong>
                    </div>
                  )
                ) : cabVendorListStatus === "pending" ? (
                  <div className="d-flex align-items-center">
                    <strong>Loading...</strong>
                    <div
                      className="spinner-border ms-auto"
                      role="status"
                      aria-hidden="true"
                    ></div>
                  </div>
                ) : cabVendorListStatus === "error" ? (
                  <div className="d-flex align-items-center">
                    <button
                      type="button"
                      className="btn btn-warning"
                      onClick={retry}
                    >
                      Retry
                    </button>{" "}
                    &nbsp;
                    <strong onClick={retry}>Please try again </strong>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
      <ConfirmationModal
        show={typeof deleteCabVendorId !== "undefined"}
        handleClose={cancelDelete}
        confirmClose={confirmDelete}
      />
      <CabVendorFormCanvas
        show={editId !== ""}
        hide={() => setEditId("")}
        editId={editId}
        Title={editId === "Add" ? "Add Cab Vendor" : "Edit Cab Vendor"}
        cabVendorData={cabVendorList?.results?.find(
          (cabVendor) => cabVendor.id === editId
        )}
      />
    </>
  );
};

export default ListCabVendors;
